
import { defineComponent } from 'vue';
import ActiveMessages from '../../nodesCanvasModule/components/ActiveMessages.vue';
import { ControlCenterState, useControlCenterStore } from '../store';
import LoadPackagesPopup from '../components/LoadPackagesPopup.vue';
import { Topic } from '@/modules/nodesCanvasModule/components/storeClasses/topic';
import { Service } from '@/modules/nodesCanvasModule/components/storeClasses/service';
import {
  getAllPackagesInWorkspace,
  checkUserAdmin
} from '@/firebase/databaseDependencyInjectables';
import { workspaceToZip } from '@/codeGeneration/codeGen';
import MountedExecute from '@/modules/packageCanvas/modules/MountedExecute.vue';
import RobotToolLaunchPopup from '../components/RobotToolLaunchPopup.vue';
import { gitAuthorization } from '@/gitIntegration/gitAuth';
import { GlobalStoreState, useGlobalStore } from '@/modules/globalModule/store';
import { LaunchFile } from '../components/robotConnection/loadLaunchFilesStrategy';
import UploadTemplatePopup from '../components/UploadTemplatePopup.vue';
import BuildPackagesPopup from '../components/BuildPackagesPopup.vue';
import {
  toCamelCase,
  toSnakeCase
} from '@/modules/globalModule/components/helperMethods';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { generatePackageLaunchFileString } from '@/codeGeneration/launchFileGen';
export default defineComponent({
  name: 'ControlCenter',
  components: {
    ActiveMessages,
    LoadPackagesPopup,
    MountedExecute,
    RobotToolLaunchPopup,
    UploadTemplatePopup,
    BuildPackagesPopup
  },
  data(): {
    store: ControlCenterState;
    globalStore: GlobalStoreState;
    loadPackages: boolean;
    topics: Topic[];
    services: Service[];
    toolDescription: string | undefined;
    toolCommand: string | undefined;
    userAdmin: boolean;
    uploadTemplate: boolean;
    buildPackagesOpen: boolean;
  } {
    return {
      store: useControlCenterStore(),
      globalStore: useGlobalStore(),
      loadPackages: false,
      topics: [],
      services: [],
      toolDescription: undefined,
      toolCommand: undefined,
      userAdmin: checkUserAdmin(),
      uploadTemplate: false,
      buildPackagesOpen: false
    };
  },
  mounted() {
    const ccStore = useControlCenterStore();
    ccStore.setWorkspaceId(this.$route.params.workspaceId as string);
    console.log(ccStore.workspaceName);
    ccStore.loadLaunchFiles();
    ccStore.loadConnections();
  },
  methods: {
    async loadMessages() {
      const ccStore = useControlCenterStore();
      await ccStore.setWorkspaceId(this.$route.params.workspaceId as string);
      await useGlobalStore().loadWorkspace(this.store.workspaceId!);
      ccStore.loadLaunchFiles();
      ccStore.loadConnections();
      this.topics = this.getTopics();
      this.services = this.getServices();
    },
    onDisconnect() {
      useControlCenterStore().disconnect();
    },
    onExit() {
      useControlCenterStore().disconnect();
      this.$router.push(`/projectManager`);
    },
    getTopics(): Array<Topic> {
      if (!this.store.workspaceId) return [];
      let packages = getAllPackagesInWorkspace(this.store.workspaceId);
      if (!packages) return [];
      let topics: Array<Topic> = [];
      Object.entries(packages)
        .filter((pkg) => pkg[1].robotPackage && pkg[1].topics)
        .forEach((pkg) => {
          topics = [...topics, ...pkg[1].topics];
        });
      return topics;
    },

    getServices(): Array<Service> {
      if (!this.store.workspaceId) return [];
      let packages = getAllPackagesInWorkspace(this.store.workspaceId);
      if (!packages) return [];
      let services: Array<Service> = [];
      Object.entries(packages)
        .filter((pkg) => pkg[1].robotPackage && pkg[1].services)
        .forEach((pkg) => {
          services = [...services, ...pkg[1].services];
        });
      return services;
    },
    buildProject() {
      this.store.workspaceId && workspaceToZip(this.store.workspaceId);
    },
    closeToolMenu() {
      this.toolDescription = undefined;
      this.toolCommand = undefined;
    },
    async openGit() {
      const gitCode = await gitAuthorization(
        this.$route.params.workspaceId as string
      );
      if (!gitCode) return;
      this.$router.push(
        `/controlCenter/${this.$route.params.workspaceId}/gitMenu`
      );
    },
    getGeneratedLaunchFiles(): Array<LaunchFile> {
      let generatedLaunchFiles: Array<LaunchFile> = [];
      this.globalStore.packages
        .filter((pkg: PackageT) => !pkg.robotPackage)
        .forEach((pkg: PackageT) =>
          generatedLaunchFiles.push({
            name: `${toSnakeCase(pkg.name)}.launch.py`,
            pkgName: pkg.name,
            path:
              this.store.previousConnections.length !== 0
                ? `${
                    this.store.previousConnections[0].buildDir
                  }/src/${toCamelCase(this.store.workspaceName)}/${toCamelCase(
                    pkg.name
                  )}/launch`
                : '-', // TODO update this with correct workspace,
            text: generatePackageLaunchFileString(pkg),
            pkgId: pkg.id
          })
        );
      return generatedLaunchFiles;
    },
    isLaunchFileRunning(launchFile: LaunchFile): boolean {
      const ccStore = useControlCenterStore();
      return ccStore.isLaunchFileRunning(launchFile) || false;
    },
    runRosVnc(command: string, display: number, windowName: string) {
      const ccStore = useControlCenterStore();
      ccStore.runRosVnc(`export DISPLAY=:${display}; ${command}`, windowName);
      this.openLink(
        `http://${ccStore.currConnection?.connectionDetails.hostname}:608${display}/vnc_auto.html`
      );
    },
    openLink(link: string) {
      window.open(link, '_blank');
    }
  }
});
